import { useMytaverse } from '@providers/MytaverseProvider';
import { useCallback, useMemo } from 'react';
import { getClientSpecificData } from '@clients/ek/helpers/clientSpecificUtils';
import { processIXRHrData } from '@clients/ek/features/avaturn/helpers';
import { IXRHrCredStatusTypes, IXRHrGenderTypes } from '@clients/ek/interfaces';
import { GenderType } from '@features/avaturn/interfaces';
import { IUserProfileHelperContext } from '@features/avaturn/pages/Avaturn/interfaces';

interface IUserProfileHelperContextClient extends IUserProfileHelperContext {
  clientSpecificData: { [key: string]: any };
}

export type useUserProfileHelperType = () => IUserProfileHelperContextClient;

export const getAvaturnBrand = (
  credentialStatus: string,
  brand: string,
): string => {
  let brandWithCreds = brand;

  if (credentialStatus?.toUpperCase() === IXRHrCredStatusTypes.Pre) {
    brandWithCreds = 'ek-no-brand';
  }

  return brandWithCreds;
};

const useUserProfileHelper: useUserProfileHelperType = () => {
  const { user } = useMytaverse();

  const clientSpecificData = useMemo(() => {
    const clientData = getClientSpecificData(user);
    return clientData ? processIXRHrData(clientData) : {};
  }, [user]);

  const getProcessedBrand = useCallback(
    () =>
      getAvaturnBrand(
        clientSpecificData.ixrCredentialStatus,
        clientSpecificData.brand,
      ),
    [clientSpecificData.ixrCredentialStatus, clientSpecificData.brand],
  );

  const getGender = useCallback(() => {
    if (!clientSpecificData?.gender) {
      return '';
    }
    return clientSpecificData?.gender?.toUpperCase() === IXRHrGenderTypes.F
      ? GenderType.FEMALE
      : GenderType.MALE;
  }, [clientSpecificData?.gender]);

  return {
    clientSpecificData,
    getProcessedBrand,
    getGender,
  };
};

export default useUserProfileHelper;
